import { render, staticRenderFns } from "./OverviewTitleBox.vue?vue&type=template&id=f0f04f9c&scoped=true"
import script from "./OverviewTitleBox.vue?vue&type=script&lang=js"
export * from "./OverviewTitleBox.vue?vue&type=script&lang=js"
import style0 from "./OverviewTitleBox.vue?vue&type=style&index=0&id=f0f04f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f04f9c",
  null
  
)

export default component.exports